import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';


import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";

import Cookies from 'js-cookie'


import Autorize from '../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Lst_Clubs_Secteur({secteur,search}) {

    const [listClub, setListClub] = useState("");   
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");
           
  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    
    useEffect(() => { 
               
            //, { headers: { Authorization: "Bearer "+ cookies }}
            if(autorize)
            {
                if(search === undefined || search === "")
                  search = "all";
                
               // console.log("--------------------------------------------------------------" +  secteur + "/" + search);
                MyAxios.get(process.env.REACT_APP_API + '/clubs/getClubBySecteur/'+ secteur + "/" + search + "/now") //axios.defaults.withCredentials = true
                .then((res) => {      
                    setErrorAxios(false);
                    console.log(res);
                    setListClub(res.data);
                
                })
                .catch((error) => {
                    console.log(error)  
                ///  if(error.status)  
                if(error.response.status === 401)// pas autorisé
                setErrorAxios(true);   

                });

        }
    },[secteur,autorize,search]);
   

    const navigate = useNavigate();       
    const dispatch = useDispatch();

    const onClicked = (value) => { 
        console.log("!*******:" + value);
        dispatch({ type: 'set' , payload:  value});
        sessionStorage.setItem('clubId',  value);
        sessionStorage.setItem('secteur',  secteur);
        navigate('/club',)
    };
                  
        
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };


    function cardStyles(ss)
    {




        if(ss.fk_club_type === 'CLUB_JOFC' )
            return { minWidth: 345 , margin:'10px',padding:'10px' , backgroundColor:'#e3f2fd'};
        else if(ss.Pending_Disbandment === 1)
            return { minWidth: 345 , margin:'10px' ,padding:'10px' , backgroundColor:'#ef9a9a' };
        else if(ss.club_enfant !== null)
             return { minWidth: 345 , margin:'10px' ,padding:'10px' , backgroundColor:'#b2ebf2' };
        else
            return { minWidth: 345 , margin:'10px' ,padding:'10px'  };


    }  

//  <Typography align="right">{ value.solde !== null ? "Solde dû: " + value.solde + " $" : "Solde dû: 0 $" }</Typography>
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
        return (
                  <div >
                     <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                     

                
                    
                 <Box   sx={{paddingLeft:'10px', display: 'flex', flexDirection: 'row',   flexWrap: 'wrap' }} >

                        {Object.entries(listClub).map(([key, value]) => (
                      
                                <Card key={value.id}  sx={cardStyles(value)}  >        
                                    <CardContent   variant="soft"  sx={{ minWidth: 345 , margin:'10px' }}    > 
                                    
                                         
                                        <Typography  component="div">
                                            <Grid container justify="space-between">  
                                                <Grid item xs={6}>
                                                    <div style={{ textAlign: 'left' }}>  <Typography align="left">Numéro de club : {value.id}</Typography> </div>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <div style={{ textAlign: 'right' }}>  <Typography align="right">{ value.fk_club_parrain !== null ? "Club parrain: " + value.fk_club_parrain   : null }</Typography>
                                                                                          <Typography align="right">{ value.Pending_Disbandment === 1 ? "En attente de dissolution" : null }</Typography>
                                                                                          <Typography align="right">{ value.club_enfant !== null ? "Parrain de " + value.club_enfant : null }  </Typography>
                                                                                          <Typography align="right">{ value.solde !== null ? "Solde dû: " + value.solde + " $" : "Solde dû: 0 $" }</Typography>

                                                                                                                                                
                                                                                                                                                 </div>
                                                </Grid>
                                              
                                            </Grid>
                                    
                                       
                                        
                                      
                                    
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">                               
                                            Province : {value.State_Province_Code }<br />
                                            Ville : {value.City }<br />
                                            Nom légal du club : {value.ClubLegalName }                                   
                                        </Typography>
                                    </CardContent>

                                    <CardActions>

                                        <Button size="small" variant="containedThird" name={value.id} onClick={(e) => onClicked(e.target.name)}>Voir</Button>    

                                    </CardActions>
                                </Card>
                          
                            
                        ))}
                 </Box>  
                
                </div>
        );
   
};

export default Lst_Clubs_Secteur;